/**
 * Same-origin relative path only. Rejects protocol-relative URLs, backslash
 * host smuggling (browsers treat `\\` as `/`), and encoded whitespace/slash
 * tricks that a regex on the raw string would miss.
 */
export function safeRedirect(value: unknown): string | undefined {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) {
    return undefined;
  }
  if (
    /\s/.test(value) ||
    /[\\]/.test(value) ||
    /%5c/i.test(value) ||
    /%09/i.test(value) ||
    /%0[da]/i.test(value)
  ) {
    return undefined;
  }

  try {
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin) return undefined;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return undefined;
  }
}
